// IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): ПРАВКА ЯЧЕЙКИ ФОРМЫ ДОВОДИТСЯ ДО ЗАПИСИ ДО ОТПРАВКИ ДЕЙСТВИЯ.
//
// Замер 14.10 (dev02, REPORT-SP5-live п.3): в форме окна остановки (поля — грид AttrTabGrid) выбрали Scope = Whole database и сразу
// открыли вкладку Preview — на бэк ушёл прежний scope "nodes" (пустой): 0 запусков. Причина — порядок событий wijmo: FlexGrid
// переносит значение открытого редактора в строку только в finishEditing, а его вызывает обработчик lostFocus (_EditHandler →
// _commitRowEdits), который Control запускает ТАЙМЕРОМ после focusout (Control._FOCUS_INTERVAL = 5 мс). Клик по вкладке
// (TabPanel.selectedIndexChanged → ленивый executeWidgetMethod) и клик по кнопке (AttrButton.onClick → executeStoreMethod)
// отрабатывают синхронно — раньше таймера, и запись уходит со старым значением. Свой mousedown-обработчик у грида закрывает
// редактор только при клике ВНУТРИ хоста грида (заголовки / ячейки), вкладка и кнопки — снаружи.
//
// Что стало. Перед отправкой действия, которое читает запись виджета (ленивая вкладка: Preview / Versions / Statistics…; кнопка
// командной панели: Save, Preview, Pause now…), открытые редакторы гридов виджета закрываются с сохранением значения
// (flex.finishEditing() — тот же путь, что и уход фокуса: cellEditEnding / cellEditEnded → строка → запись). То, что раньше
// случалось через 5 мс, делается до отправки; повторный finishEditing при уходе фокуса — пустой (редактора уже нет).
// Выключатель fe.ux.commitEditsBeforeAction (по умолчанию ВКЛ): window.feSettings.set('fe.ux.commitEditsBeforeAction', false)
// или ?fe.ux.commitEditsBeforeAction=false — прежнее поведение. Счётчики: window.editCommit.stats() / .clear().

export const FLAG = 'fe.ux.commitEditsBeforeAction'

const stats = {
    calls: 0,        // вызовов перед действием
    committed: 0,    // закрытых редакторов (значение доведено до строки)
    failed: 0,       // finishEditing отказал (валидация ячейки) — действие всё равно уходит, как при уходе фокуса
}

export function editCommit_on(store) {
    return !store || typeof store.setting !== 'function' || store.setting(FLAG, true) !== false
}

// Закрыть открытые редакторы гридов виджета с сохранением значения. Возвращает число закрытых редакторов (0 — нечего было закрывать
// или выключатель снят). Гриды — компоненты реестра WIDGET.attrs_vueObj с живым wijmo-гридом (vueObj.flex) и активным редактором.
export function editCommit_pending(WIDGET, store, why = '') {
    if (!WIDGET || !editCommit_on(store)) return 0
    stats.calls++
    let n = 0
    for (const vueObj of Object.values(WIDGET.attrs_vueObj || {})) {
        const flex = vueObj?.flex
        if (!flex || !flex.activeEditor || typeof flex.finishEditing !== 'function') continue
        let ok = false
        try { ok = flex.finishEditing() !== false } catch (err) { ok = false; void err /* редактор уже закрыт */ }
        if (ok) { n++; stats.committed++ } else stats.failed++
        if (why && typeof window !== 'undefined' && window.editCommit?.trace) console.log(`editCommit: ${why} → finishEditing ${ok ? 'ok' : 'refused'}`, vueObj.attr?.name || vueObj.attr?.binding || '')
    }
    return n
}

export function editCommit_console(store) {
    if (typeof window === 'undefined') return
    window.editCommit = {
        flag: FLAG,
        trace: false,
        get: () => ({ on: editCommit_on(store), stats: { ...stats } }),
        set(value) { window.feSettings?.set?.(FLAG, value); return this.get() },
        reset() { window.feSettings?.unset?.(FLAG); return this.get() },
        stats: () => ({ ...stats }),
        clear() { for (const k of Object.keys(stats)) stats[k] = 0; return { ...stats } },
        help: () => 'editCommit.set(false) — прежнее поведение (редактор ячейки закрывается только уходом фокуса); .reset() — снять override; .stats() / .clear() — счётчики; .trace = true — лог в консоль',
    }
}
